import React from 'react';
import { motion } from 'framer-motion';

const HowWeBuild = () => {
  const process = [
    { title: 'Scope', desc: 'We define exactly what needs to be built and why. No marketing fluff, just the roadmap to a working product.' },
    { title: 'Build', desc: 'Rapid, precision development. We provide weekly updates so you see the progress as it happens, not just at the end.' },
    { title: 'Ship & Improve', desc: 'We launch the product and then iterate based on real usage patterns. We stay with you to handle improvements.' },
  ];

  return (
    <section className="pt-40 pb-24 bg-[#07113a]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-[#3b82f6] font-bold tracking-widest uppercase text-xs mb-4 block">Process over Tools</span>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-12 tracking-tight uppercase">
            How we build
          </h1>

          <div className="space-y-12 text-xl text-[#e2e8f0] leading-relaxed font-medium mb-24">
            <p>
              We don't lead with tools because tools change. Whether it's a website for a local bistro or a complex SaaS application, the fundamental challenge is the same: clarity of scope and speed of execution.
            </p>
            <p>
              Our approach is built on outcomes, timeline, and dependability. When you work with Crucible Lab, you aren't just getting code—you're getting a partner who knows how to ship.
            </p>
          </div>

          <div className="grid gap-10 mb-24">
            {process.map((step, index) => (
              <div key={index} className="bg-[#2a3658] border border-[#344271] p-12 rounded-[48px] relative overflow-hidden group backdrop-blur-sm shadow-2xl transition-all hover:bg-[#344271]">
                <div className="text-[12rem] font-black text-[#3b82f6]/5 absolute -right-8 -bottom-16 select-none group-hover:text-[#3b82f6]/10 transition-colors pointer-events-none">{index + 1}</div>
                <h3 className="text-4xl font-black text-white mb-6 relative z-10 tracking-tight uppercase">{step.title}</h3>
                <p className="text-[#e2e8f0] text-xl leading-relaxed relative z-10 max-w-2xl font-medium">{step.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-24 pt-24 border-t border-[#344271]">
            <h3 className="text-3xl font-black text-white mb-8 uppercase tracking-tight">What working with Claton looks like</h3>
            <ul className="grid sm:grid-cols-2 gap-6">
              {[
                'Built in Rapid City',
                'Direct access',
                'Proven across 13+ shipped products',
                'Active client work',
                'Time-zone aligned with US Central',
                'No account managers'
              ].map((item, index) => (
                <li key={index} className="flex items-center space-x-4 bg-[#2a3658]/30 p-6 rounded-2xl border border-[#344271]">
                  <div className="w-2 h-2 bg-[#3b82f6] rounded-full"></div>
                  <span className="text-[#e2e8f0] font-bold uppercase tracking-tight text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowWeBuild;